import angular from 'angular';
import * as R from 'ramda';

export default function SelectReportTypesDialogController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  loaderService,
  reportsDataService,
  reportsSharedModelService,
  alerts,
  selectEditTypeDialog,
  selectReportParametersDialog,
) {
  const vm = this;

  vm.hasData = false;
  vm.appIsLoaded = false;
  
  vm.filter = [];
  vm.filter.categories = [];

  vm.filteredReportTypes = [];

  vm.selectedAll = false;

  vm.selectedEditTypeId = 1;

  vm.handleGoBack = _handleGoBack;
  vm.handleSubmitReportTypes = _handleSubmitReportTypes;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSelectAll = _handleSelectAll;
  vm.handleFilterChange = _handleFilterChange;
  

  _activate();

  // //////// METHODS //////////

  function _activate() {
    return _getReportTypes().then(() => {
      _handleFilterChange();
      vm.appIsLoaded = true;
    });
  }

  function _getReportTypes() {
    loaderService.showViewLoader = true;

    return $q.all([
      reportsSharedModelService.getScheduledReportSummary(1, true),
      reportsDataService.getReportParameterReportTypesByReportPackage(vm.reportPackage.reportPackageId, false),
    ]).then(response => {
      vm.categories = [];

      vm.reportTypes = response[0];      
      const selectedReportTypes = response[1].data.result;

      angular.forEach(vm.reportTypes, (reportType, rtIndex) => {
        angular.forEach(selectedReportTypes, (selectedReportType, srtIndex) => {
          if (reportType.reportGroupId === selectedReportType.reportGroupId) {
            reportType.isSelected = true;
          }
        });

        let _found = false;

        angular.forEach(vm.filter.categories, (category) => {
          if (category.value === reportType.groupId) {
            _found = true;
          }
        });
        
        if (!_found) {
          const categoryFilter = {
            name: reportType.groupName,
            value: reportType.groupId,
          };

          vm.filter.categories.push(categoryFilter);
        }
      });

      if ((vm.reportTypes !== null) && (vm.reportTypes.length > 0)) {
        vm.hasData = true;
      }

      if ((vm.filter.categories !== null) && (vm.filter.categories.length > 0)) {
        vm.filter.categories = vm.filter.categories.sort((a, b) => a.name.localeCompare(b.name));
      }

      loaderService.showViewLoader = false;
    });
  }

  function _handleGoBack($event) {
    ssDialogService.hide(ssDialogService.dialogs.reports.selectReportTypesDialog);
    
    ssDialogService.dialogs.reports.selectEditTypeDialog = ssDialogService.alert(
      selectEditTypeDialog.getOptions($event, {
        hasAdvisoryServices: vm.hasAdvisoryServices,
        reportPackage: vm.reportPackage,
        selectedEditTypeId: 1,
        attachCallback: vm.documentAttached,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.selectEditTypeDialog);
  }

  function _handleSubmitReportTypes($event) {

    let selectedReportTypes = [];

    angular.forEach(vm.reportTypes, (reportType, index) => {
      if (reportType.isSelected) {
        reportType.reportPackageId = vm.reportPackage.reportPackageId;
        selectedReportTypes.push(reportType);
      }
    });

    _saveSelectedReportTypes(vm.reportPackage.reportPackageId, selectedReportTypes).then(() => {
      if (vm.saveType === 'saveAndSelectParameters') {
        _handleCloseDialog();
        ssDialogService.dialogs.reports.selectReportParametersDialog = ssDialogService.alert(
          selectReportParametersDialog.getOptions($event, {
            hasAdvisoryServices: vm.hasAdvisoryServices,
            reportPackageId: vm.reportPackage.reportPackageId,
            reportPackage: vm.reportPackage,
            editMode: 1,
          }),
        );
        return ssDialogService.show(ssDialogService.dialogs.reports.selectReportParametersDialog);
      }
    });
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.selectReportTypesDialog);
  }
  
  function _handleSelectAll() {
    R.forEach((reportType) => {
        reportType.isSelected = vm.selectAll;
      }, vm.filteredReportTypes );
  }  

  function _handleFilterChange() {
    let _reportTypes = [];

    if ((vm.selectedCategories !== undefined) && (vm.selectedCategories !== null) && (vm.selectedCategories.length > 0)) {
      angular.forEach(vm.reportTypes, (reportType) => {
        angular.forEach(vm.selectedCategories, (category) => {
          if (reportType.groupId === Number(category)) {
            _reportTypes.push(reportType);
          }
        });
      });
    } else {
      _reportTypes = vm.reportTypes;
    }

    vm.filteredReportTypes = _reportTypes;
  }

  function _saveSelectedReportTypes(reportPackageId, selectedReportTypes) {
    loaderService.showViewLoader = true;
    const dfdSave = $q.defer();

    if ((reportPackageId !== null) && (reportPackageId > 0)) {
      reportsDataService.saveBulkReportParameterReportTypes(reportPackageId, selectedReportTypes).then((response) => {
        const savedReportPackage = response.data;
        if (savedReportPackage === 'undefined' || savedReportPackage === false) {
          // There was an error saving the Report Package information
          alerts.error('Error occurred while saving the Report Package Selected Reports.');
          loaderService.showViewLoader = false;
          dfdSave.reject();
        } else {
          // The Report Package Selected Reports information has been saved
          alerts.success('The Report Types included in the Package have been updated successfully.');
          $rootScope.$broadcast('refreshReportPackageConfiguration', {
            reportPackageId: Number(reportPackageId),
          });  
          loaderService.showViewLoader = false;
          dfdSave.resolve();
        }
      });
    } else {
      loaderService.showViewLoader = false;
      dfdSave.reject();
    }

    return dfdSave.promise;
  }
}

SelectReportTypesDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
  'reportsSharedModelService',
  'alerts',
  'selectEditTypeDialog',
  'selectReportParametersDialog',
];
